<template>

  <div class="outer">

    <div class="chat_box" id="chat_block">
      <div class="chat_box_title">
        <img src="http://test.immvira.cn/upload/20200715/159480613509821.jpg"/>
        <span>Client: {{ uid }}</span>
      </div>

      <div class="chat_box_content">
        <div :key="index" v-for="(msg,index) in chatRecord" :class="[msg.type==1?'client':'server']">
          <span :class="['msg',msg.type==1?'client':'server']">{{ msg.content }}</span>
        </div>
      </div>

      <div class="chat_box_input">
        <textarea id="message_text" placeholder="请输入你所遇到的问题" @keypress="toSend($event)"></textarea>
      </div>
      <div id="send-btn" @click="sendMsg()">发送</div>
    </div>
  </div>

</template>

<script>
import base from '@/api/common';

export default {
  name: "chatClient",
  data() {
    return {

      default_open: false,
      wsUrl: base.api.chat,
      welcome_message: "你好，请详细说明一下您的问题，客服将竭力为您解决！",
      webSocket: null,
      uid: '',

      chatRecord: [],
    }
  },
  mounted() {

    window.console.font = function (msg, size, color, bgColor) {
      if (isNaN(Number(size))) {
        size = 12
      }
      if (size > 50 || size < 12) {
        size = 12;
      }
      if (!color) {
        color = "#fff"
      }
      if (!bgColor) {
        bgColor = "green"
      }
    };

    this.$router.app.$children[0].$data.type = 'none';

    let item = localStorage.getItem("uid");
    if (item) {
      this.uid = item;
    } else {
      this.uid = Math.random().toString(32).substr(2, 4)
      localStorage.setItem("uid", this.uid);
    }

    if (this.default_open) {
      this.initWebSocket();
    }

    if (this.welcome_message) {
      this.chatRecord.push({
        date: new Date().getTime(),
        content: this.welcome_message,
        type: 0,
      });
    }
    // 回显本地记录
    let record = sessionStorage.getItem("chat_" + this.uid);
    if (record != null) {
      this.chatRecord = this.chatRecord.concat(JSON.parse(record));
      console.log("恢复本地记录...");
      this.$nextTick(function () {
        setTimeout(this.scrollToLast, 1000)
      });
    }

  },
  methods: {
    toSend(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.sendMsg();
      }
    },
    sendMsg() {
      let message = $("#message_text").val();
      if ($.trim(message).length === 0) {
        return;
      }
      let that = this;

      function send() {
        try {
          let data = {msg: message};
          that.saveLocalChat({
            type: 1,
            date: new Date().getTime(),
            content: message
          });
          that.webSocket.send(JSON.stringify(data));
        } catch (e) {
          console.error(e);
          alert("发送失败");
          return;
        }
        that.chatRecord.push({
          date: new Date().getTime(),
          content: message,
          type: 1,
        });
        that.$nextTick(that.scrollToLast());
        $("#message_text").val("");
      }

      if (!this.webSocket) {
        this.initWebSocket(function () {
          send();
        });
      } else {
        send();
      }

    },
    initWebSocket(then) {
      let that = this;
      this.webSocket = new WebSocket(that.wsUrl + that.uid);
      this.webSocket.onopen = function () {
        console.font("webSocket is on opened....", 14, "#FFF", "green");
        if (then) {
          then();
        }
      };
      this.webSocket.onclose = function () {
        that.webSocket = null;
        console.font("webSocket is on closed....", 14, "#000", "#E9DA75");
      };
      this.webSocket.onerror = function (e) {
        that.webSocket = null;
        console.font("webSocket error....", 14, "#FFF", "#F00");
        console.error(e);
      }
      this.webSocket.onmessage = function (event) {
        let message = JSON.parse(event.data);
        let msgData = {
          type: 0,
          date: new Date().getTime(),
          content: message.msg,
        };
        that.chatRecord.push(msgData);
        that.$nextTick(that.scrollToLast());
        that.saveLocalChat(msgData);
      }
    },
    scrollToLast() {
      let maxHeight = $(".chat_box_content")[0].scrollHeight;
      $(".chat_box_content").animate({scrollTop: maxHeight}, 800);
      $("#message_text").focus();
    },
    saveLocalChat(msgObj) {
      if (this.uid) {
        let record = sessionStorage.getItem("chat_" + this.uid);
        let data = [];
        if (record) {
          data = JSON.parse(record);
        }
        data.push(msgObj);
        sessionStorage.setItem("chat_" + this.uid, JSON.stringify(data));
      }
    }


  },
}

</script>

<style>
#app {
  min-width: unset;
  overflow: hidden;
}

.mt36 {
  margin: 8px
}
</style>
<style scoped>
.chat_box {
  width: 100vw;
  height: 100vh;
  min-width: 400px;
  min-height: 500px;
  border-radius: 0;
  box-shadow: 0 0 4px 2px #bdbdbd;
  position: relative;
}

.chat_box_title {
  height: 60px;
  background: #567BFF;
  border-radius: 0;
  color: #ffffff;
  font-size: 20px;
  line-height: 60px;
  padding-left: 6%;
}

.chat_box_title img {
  width: 40px;
  border-radius: 50%;
  vertical-align: middle;
  position: relative;
  top: -4px;
}

#send-btn {
  position: absolute;
  bottom: 18px;
  right: 30px;
  width: 50px;
  height: 24px;
  border-radius: 12px;
  line-height: 24px;
  font-size: 12px;
  background: #FC7B66;
  color: #FFF;
  text-align: center;
  cursor: pointer;
}

.chat_box_input {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  box-sizing: border-box;
  border-top: 1px solid #567BFF;
}

.chat_box_input textarea {
  border: none;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  resize: none;
}

.chat_box_content {
  width: 100%;
  height: 436px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.chat_box_content::-webkit-scrollbar {
  display: none
}

.chat_box_content .msg {
  /*width: 90%;*/
  display: inline-block;
  margin: 4px 10px;
  border-radius: 0;
  font-size: 12px;
  padding: 14px 20px;
  box-sizing: border-box;
  position: relative;
}

.chat_box_content div.client {
  text-align: right;
}

.chat_box_content span.msg.server {
  background: #F0F0F0
}

.chat_box_content span.msg.client {
  background: #EEF2FF
}

.chat_box_content span.msg.server:before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent #F0F0F0 transparent transparent;
  border-style: solid;
  position: absolute;
  top: 6px;
  left: -18px;
  z-index: 99;
  box-sizing: content-box;
}

.chat_box_content span.msg.client:after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent transparent transparent #EEF2FF;
  border-style: solid;
  position: absolute;
  top: 6px;
  right: -18px;
  z-index: 99;
  box-sizing: content-box;
}

#message_text {
  outline: none;
}

#message_text:focus {
  border: 1px solid #567bff;
}
</style>
